import { Component, input, InputSignal, output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TEST_INSTRUCTION } from 'src/app/constants/ui-strings';
import { ProctorSetting } from 'src/app/model/proctor-setting';

@Component({
  selector: 'app-instruction',
  templateUrl: './instruction.component.html',
  styleUrl: './instruction.component.scss'
})
export class InstructionComponent {
  proctorSetting: InputSignal<{
    enforce_camera: boolean;
    enforce_fullscreen: boolean;
    max_tab_allowed: string;
  }> = input<ProctorSetting>();
  checkBox: InputSignal<boolean> = input<boolean>();
  scrolledToEnd = output<boolean>();
  instruction = TEST_INSTRUCTION;
  confirm: FormControl = new FormControl(false,[Validators.required]);
  
  onClick(): void {
    this.confirm.markAsTouched();
    if (this.confirm.valid) {
      this.scrolledToEnd.emit(true);
    } else {
      this.scrolledToEnd.emit(false);
    }
  }
}
